




















import { Component, Vue } from "vue-property-decorator";
import { mapState, } from "vuex";
import { ScheduleView } from "@/store/modules/enums";


@Component({
    computed: {
        ...mapState("schedule", ["view", "list", "reminderCount"]),
    },
})
export default class Pager extends Vue {
    view!: ScheduleView;
    list!: any;
    reminderCount!: any;

    get ScheduleView() {
        return ScheduleView;
    }

    get totalReminder(){
        //return this.reminderCount.map((r) => r.count).filter((v, i, a) => a.indexOf(v) === i).reduce((accumulator, value) => accumulator + value, 0);
        return this.reminderCount.filter(r => r.type !="AVP" && r.type !="ERR").map((r) => r.count).reduce((accumulator, value) => accumulator + value, 0);
    }


    setReminderTypeFilter(value: string) { 
        if(value =="VBP"){
            this.list.filter.reminderType = value;
            this.list.filter.viewedByPatient = true;
        }else{
            this.list.filter.reminderType = value;
            this.list.filter.viewedByPatient = false;
        }
  } 
}
